import React, { ReactElement } from 'react';
interface IWYPBannerIconProps {
  customStyle?: any;
  width?: string | number;
  height?: string | number;
}

const WYPBannerIcon = ({ customStyle, ...rest }: IWYPBannerIconProps): ReactElement => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={customStyle}
      {...rest}
    >
      <g clipPath="url(#clip0_578_4473)">
        <path d="M56.0256 0H0.0256348V56H56.0256V0Z" fill="#F6F4F4" />
        <path d="M56.0256 0V56H0.0256348L56.0256 0Z" fill="url(#paint0_linear_578_4473)" fillOpacity="0.35" />
        <path
          d="M39.8876 11.1179C41.2808 10.7673 42.7913 11.868 42.7913 13.412V44.7801C42.7913 47.1216 40.8911 49 38.57 49H17.3719C15.0325 49 13.1506 47.1033 13.1506 44.7801V13.412C13.1506 11.3501 15.6478 10.2668 17.1413 11.756C17.142 11.7567 17.1427 11.7574 17.1434 11.7581L25.1626 19.7414L25.1641 19.7428C26.7169 21.2946 29.2478 21.2946 30.8007 19.7428L39.4315 11.1179H39.8876Z"
          fill="#F6F4F4"
        />
        <path
          d="M40.3372 13.3054L32.3469 21.2902C29.9399 23.6955 26.0248 23.6955 23.6178 21.2902L15.5971 13.3054C15.4981 13.2065 15.3381 13.275 15.3381 13.412V44.7802C15.3381 45.8991 16.2446 46.8125 17.3719 46.8125H38.57C39.6897 46.8125 40.6038 45.9067 40.6038 44.7802V13.412C40.6038 13.275 40.4362 13.2065 40.3448 13.3054H40.3372Z"
          fill="#E21D4A"
        />
        <path
          d="M34.274 35.4483L34.0836 35.6386C34.0836 35.6386 28.6222 40.16 27.9671 41.7508C27.3121 40.16 21.8507 35.6386 21.8507 35.6386L21.6602 35.4483C20.0607 33.8498 19.8017 31.2618 21.2413 29.5263C22.8866 27.532 25.8496 27.4254 27.6396 29.2142L27.9671 29.5415L28.2946 29.2142C30.0846 27.4254 33.0477 27.532 34.6929 29.5263C36.1326 31.2694 35.8736 33.8574 34.274 35.4483Z"
          fill="white"
        />
        <path
          d="M30.6636 19.1133L40.3372 9.4463C40.4362 9.34735 40.3676 9.1875 40.2305 9.1875H15.7037C15.5666 9.1875 15.4981 9.35496 15.5971 9.4463L25.2631 19.1057C26.7484 20.59 29.1782 20.59 30.6636 19.1057"
          fill="#C0103E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_578_4473"
          x1="28.0256"
          y1="28"
          x2="56.0256"
          y2="56"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.270348" stopColor="#D2D6DB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_578_4473">
          <rect width="56" height="56" fill="white" transform="translate(0.0256348)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WYPBannerIcon;
